import React from "react";

const Testimonials = ({ testimonials = [] }) => {
  return (
    <section className="py-24 bg-[#0b1a35] px-6 text-center">

      {/* SINGLE CLEAN HEADING */}
      <h2 className="text-4xl font-bold mb-4">
        Client <span className="text-purple-400">Testimonials</span>
      </h2>

      <p className="text-gray-400 mb-16">
        What our clients say about us
      </p>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="bg-[#112240] p-6 rounded-xl border border-white/10 hover:scale-105 transition"
          >
            <p className="text-gray-300 italic mb-4">
              “{t.feedback}”
            </p>

            <h4 className="text-purple-400 font-semibold">
              {t.name}
            </h4>

            <p className="text-gray-500 text-sm">
              {t.role}
            </p>
          </div>
        ))}
      </div>

    </section>
  );
};

export default Testimonials;